import { Alert, AlertDescription, Button, Input, Label } from '@sitewise/ui';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';


import { forgotPassword } from '../../api/auth.js';

import { AuthShell } from './auth-shell.js';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const mutation = useMutation({
    mutationFn: () => forgotPassword(email),
  });

  return (
    <AuthShell
      title="Reset your password"
      description="If an account with that email exists, we'll send a reset link."
      footer={
        <Link to="/login" className="text-fg hover:underline">
          Back to sign in
        </Link>
      }
    >
      {mutation.isSuccess ? (
        <Alert variant="success">
          <AlertDescription>
            Check your inbox at <strong>{email}</strong>. The link expires in 30 minutes.
          </AlertDescription>
        </Alert>
      ) : (
        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
          noValidate
        >
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={mutation.isPending}>
            {mutation.isPending ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
